import Field from './Field'

export default function FieldInput (label, key, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'input'
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldInput.js